export const floatButtonPrefixCls = 'float-btn';
